var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M6.898 7.617a.56.56 0 0 1-.796 0L.367 1.882a.56.56 0 0 1 0-.795L.633.82c.22-.22.575-.22.795 0L6.5 5.893 11.572.821c.22-.22.576-.22.795 0l.266.266c.22.22.22.575 0 .795z",
  clipRule: "evenodd"
})));
export default SvgChevronDown;